export enum ICalendarItemType {
    /*
    None = 0,
    Booking = 1,
    Blocked = 2
    */
    'available' = 0,
    'se360-booking' = 1,
    'scandphotos-booking' = 2,
    'blocked' = 4,
    'travel' = 8
}

export enum ICalendarItemUserType {
    Photographer,
    StylingUser
}

export interface IBookableOrderInfo {
    availableContactPersons: any[];
    contactPerson: number;
    isCommercial: boolean;
    willAttendWhenPhotographing: boolean;
}

export interface IBookableOrderAddressInfo {
    description: string;
    address_line1: string;
    address_line2: string;
    zip: string;
    city: string;
    district: string;
    objectTypeId: number;
    objectType: string;
    objectAreaSquareMeters: number;
    objectNumberofRooms: number;
    apartmentHasBalcony: boolean;
    apartmentFloor: number;
    apartmentAccessCode: string;
}

export interface IBookableOrderContactInfo {
    fullName: string;
    firstName: string;
    lastName: string;
    company: string;
    secondaryPhoneNumber: string;
    primaryPhoneNumber: string;
    email: string;
}

export interface ICalendarItem {
    id?: number;
    userId: number;
    userName: string;
    orderId: number;
    title: string;
    description: string;
    numberOfImages: number;
    type: ICalendarItemType;
    allDay: boolean;
    start: Date;
    end: Date;
    editable: boolean;
    productProperties: any[];
    site?: number;
    className: string[];
    isBackgroundEvent: boolean;
    orderNumber: string;
    photographerInformationFromChain: string;
    photographerInformationFromFirm: string;
    photographerInformationFromOrder: string;
    bookableOrderInfo: IBookableOrderInfo;
    bookableOrderAddressInfo: IBookableOrderAddressInfo;
    bookableOrderOwnerContactInfo: IBookableOrderContactInfo;
    bookableOrderBrokerContactInfo: IBookableOrderContactInfo;
    photographerInstructions: any[];
    isDusk: boolean;
    baseLocation: string;
    blockingLocation: string;
    coordinates: string;
    isExisting: boolean;
}

export interface ICalendarItemDetailed {
    id?: number;
    userId: number;
    userName: string;
    orderId: number;
    title: string;
    description: string;
    numberOfImages: number;
    type: ICalendarItemType;
    allDay: boolean;
    start: Date;
    end: Date;
    editable: boolean;
    productProperties: any[];
    site?: number;
    className: string[];
    isBackgroundEvent: boolean;
    orderNumber: string;
    photographerInformationFromChain: string;
    photographerInformationFromFirm: string;
    photographerInformationFromOrder: string;
    bookableOrderInfo: IBookableOrderInfo;
    bookableOrderAddressInfo: IBookableOrderAddressInfo;
    bookableOrderOwnerContactInfo: IBookableOrderContactInfo;
    bookableOrderBrokerContactInfo: IBookableOrderContactInfo;
    photographerInstructions: any[];
}

export interface ICalendarItemBasic {
    id?: number;
    userId: number;
    photographerName: string;
    orderId: number;
    title: string;
    description: string;
    type: ICalendarItemType;
    allDay: boolean;
    start: Date;
    end: Date;
    editable: boolean;
    site?: number;
    isBackgroundEvent: boolean;
}

interface IEventSource {
    events: ICalendarItem[];
}

export interface ICalendarSettings {
    id: string;
    eventSources: IEventSource[];
    disableResizing: boolean;
}

export interface IErrorResult {
    type: IErrorResultType;
    userName: string;
    userId: number;
    statusCode: number;
    originAddress: string;
    destinationAddress: string;
}

export enum IErrorResultType {
    'TopLevel' = 0,
    'ElementLevel' = 1
}

export default ICalendarItem;
